import Link from "next/link";

import { BlockShort } from "@/api/generatedTypes";
import { useIntersectionIndicies } from "@/hooks/useIntersectionIndicies";

import { VideoItem } from "../VideoItem";
import styles from "./BlockItem.module.scss";

interface BlockItemProps {
  block: BlockShort;
  index: number;
}

const BlockItem = ({ block, index }: BlockItemProps) => {
  const { blockRef, visibleIndices } = useIntersectionIndicies(index);

  const isVideo =
    !!block.thumbnail.poster && block.thumbnail.content_type === "video";

  return (
    <Link href={`/block/${block.id}`} ref={blockRef} className={styles.link}>
      {isVideo ? (
        <VideoItem
          url={block.thumbnail.url}
          poster={block.thumbnail.poster || ""}
          hidden={!visibleIndices.includes(index)}
        />
      ) : (
        <img src={block.thumbnail.url} alt="block image" />
      )}
    </Link>
  );
};

export default BlockItem;
